var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.228 12l.622-1.92c.465-1.437-.182-3-1.527-3.687l-1.797-.918-.918-1.797A3.076 3.076 0 0 0 13.92 2.15L12 2.77l-1.92-.621a3.077 3.077 0 0 0-3.687 1.527l-.92 1.797-1.796.919A3.077 3.077 0 0 0 2.15 10.08L2.772 12l-.622 1.92c-.465 1.437.182 3 1.527 3.687l1.797.918.918 1.797a3.076 3.076 0 0 0 3.687 1.527l1.92-.621 1.92.622c1.438.465 3-.182 3.688-1.527l.918-1.797 1.797-.918a3.076 3.076 0 0 0 1.527-3.687L21.228 12zM11 16.414l-3.707-3.707 1.414-1.414L11 13.586l5.293-5.293 1.414 1.414L11 16.414z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.a09c53d4d950d1ca1afb8c7ebccd59b6.svg";
export { ForwardRef as ReactComponent };